import { useState, useEffect } from 'react';
import TextField from '@material-ui/core/TextField';
import { makeStyles } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import { Helmet } from 'react-helmet';
import { Link, Redirect } from 'react-router-dom';
import * as EmailValidator from 'email-validator';
import { connect } from 'react-redux';
import { compose } from "redux";
import { firestoreConnect } from "react-redux-firebase";
import { signIn } from '../../Firebase/actions/authActions';

const useStyles = makeStyles({
    field: {
        marginTop: 25,    
       
    },
    btn: {
        marginBottom: 25,
        marginTop: 30
    }
});


const AdminLogIn = ({ signIn, admins, auth, authError, profile, resetError }) => {
    const classes = useStyles();
    const [ email, setEmail ] = useState('');
    const [ password, setPassword ] = useState('');
    const [ error, setError ] = useState(null);
    const [ pwdToogle, setPwdToogle] = useState('Show Password');

    const tooglePwdVisibility = () => {
        let passwordField = document.getElementById('passwordField');
        if(pwdToogle === 'Show Password') {           
            passwordField.setAttribute("type", "text");
            setPwdToogle('Hide Password');
        }
        if(pwdToogle === 'Hide Password') {        
            passwordField.setAttribute("type", "password");
            setPwdToogle('Show Password');
        }
        
    }

    const handleSubmit = (e) => {
        e.preventDefault();

        if(email === '' || password === ''){
            setError('Provide a valid email and password.')
        } else {
            setError(null);
            if(!EmailValidator.validate(email)){
                setError('Please provide a valid email.');
            } else {
                setError(null);
                document.getElementById('Btn').innerHTML = 'Logging In';
                //go to auth
                signIn(email, password);
            }
        }
        //console.log(email, password);
    }

    useEffect(() => {
        
        if(authError) {
            document.getElementById('Btn').innerHTML = 'Log In';
            setError(authError);
            //console.log('eerr');
            resetError();
        } else {
            document.getElementById('Btn').innerHTML = 'Log In';
        }
    }, [authError, resetError]);

    if(auth.uid) {
        if(profile.idNumber) return <Redirect to="/portal" />
        //console.log(profile.id)
        let admin;
        let output;
        
        if (admins) {
            
            admin = admins.filter((item) => {
                return item.id === auth.uid
            });  
            
            output = admin[0];     //console.log(output, auth);

           
            if(output && output.adminLevel === 'Main') {
          
                return <Redirect to="/admin-main" />
            } else if (output && output.adminLevel === 'Teacher') {
                //console.log('lll');
                return <Redirect to="/admin-teacher" />
            } else if (output && output.adminLevel === 'Bursary') {
                //console.log('lll');
                return <Redirect to="/admin-bursary" />
            } 
            //console.log(output, output.adminLevel)
            
        }     
    }


    return ( 
        <>
             <Helmet> 
                <meta
                    name="description"
                    content="Life Long Polytechnic"
                />
                <title>Administration Log In</title>
            </Helmet>
            <div className="wrapper light-bg py-3">
                <div className="container">
                    <div className="center">
                        <h4 className="is-size-4-touch is-size-3-desktop has-text-weight-bold grey-text text-darken-2">Life Long Polytechnic</h4>
                    </div>
                    <div className="center">
                        <img src="img/logo.png" alt="Life Long Polytechnic Logo" className="logo-form2 mb-3" />
                    </div>
                    <div className="row">
                        <div className="col s12 m8 l6 offset-m2 offset-l3 box center px-6 py-3">
                            <form noValidate autoComplete="off" className="bb-none" onSubmit={handleSubmit}>
                                {
                                    error && <p className="mt-1 main-color-text">{error}</p>
                                }
                                <TextField 
                                    type="email"
                                    label="Email"
                                    variant="outlined"
                                    color="secondary"
                                    className={classes.field}
                                    fullWidth
                                    onChange={(e) => setEmail(e.target.value)}
                                    value={email}
                                    // error={true}
                                />
                                <TextField 
                                    type="password"
                                    label="Password"
                                    variant="outlined"
                                    color="secondary"
                                    className={classes.field}
                                    fullWidth
                                    onChange={(e) => setPassword(e.target.value)}
                                    value={password}
                                    id="passwordField" 
                                    autoComplete="false"    
                                />
                                {
                                    pwdToogle === 'Show Password' ? (
                                        <div 
                                            className="left-align small-text has-text-weight-light mt-3 cursor-pointer"
                                            onClick={tooglePwdVisibility}
                                        >
                                            Show Password
                                        </div>
                                    ) : (
                                        <div 
                                            className="left-align small-text has-text-weight-light mt-3 cursor-pointer"
                                            onClick={tooglePwdVisibility}
                                        >
                                            Hide Password
                                        </div>
                                    )
                                }
                                <Button
                                    className={classes.btn}
                                    type="submit"
                                    color="primary"
                                    variant="contained"
                                    fullWidth
                                    id="Btn"
                                >
                                    Log In
                                </Button>
                                <p className="mb-2"> 
                                    <Link to="/reset-password" className="grey-text text-darken-2 has-text-weight-light mb-2">Forgot Password ?</Link>
                                </p>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>
     );
}
 
const mapStateToProps = (state) => {
    //console.log(state)
    return {
        admins: state.firestore.ordered.admins,
        auth: state.firebase.auth,
        authError: state.auth.authError,
        profile: state.firebase.profile
    }
    
}

const mapDispatchToProps = (dispatch) => {
    return{
        signIn: (email, password) => dispatch(signIn(email, password)),
        resetError: () => dispatch({ type: "SIGN_IN_ERR", authError: false })
    }
}
export default compose(
    connect(mapStateToProps, mapDispatchToProps),
        firestoreConnect((ownProps) => [
            {
                collection: "admins", 
            },
    ])
)(AdminLogIn);
